import { Permission } from "generated-graphql/graphql";
import { useAuthorization } from "hooks/useAuthorization";

/**
 * Whether this viewer may save a manifest document review, as distinct from
 * seeing its state.
 *
 * Every surface that offers a way INTO the review has to agree with the one
 * that opens it. `ReviewPermalink` refuses a viewer without the write, so a
 * button elsewhere that does not ask the same question sends them to a dialog
 * that declines to open — the comparison closes and nothing replaces it.
 *
 * The resolvers grant the read without the write on purpose, so this cannot be
 * inferred from being able to see a manifest.
 */
export function useCanReviewDocuments(): boolean {
  const { hasPermissions } = useAuthorization();
  return hasPermissions([Permission.WriteDocument]);
}
